module.exports = __webpack_public_path__ + "img/pink-gold.29f389ea.png";